import { MOBILE_NAV, type AppTab } from "@/modules/shell/tabs";

export function MobileNav({
  tab,
  sessionOn,
  onChange,
}: {
  tab: AppTab;
  sessionOn: boolean;
  onChange: (t: AppTab) => void;
}) {
  const guest = !sessionOn;
  const items = guest
    ? MOBILE_NAV.filter((n) => n.id === "home" || n.id === "market" || n.id === "trade")
    : MOBILE_NAV;

  const active: AppTab =
    tab === "shops" || tab === "oracle" || tab === "pay" || tab === "inbox"
      ? "home"
      : tab === "auth"
        ? "home"
        : tab;

  return (
    <nav
      className="mobile-nav wx-bottom-nav"
      style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}
      aria-label="منوی موبایل"
    >
      {items.map((n) => (
        <button
          key={n.id}
          type="button"
          className={active === n.id ? "nav active" : "nav"}
          onClick={() => onChange(n.id)}
        >
          <span className="ico" aria-hidden="true">
            {n.ico}
          </span>
          {n.label}
        </button>
      ))}
    </nav>
  );
}
